import { articlesNewsData } from "../../data/data";
import styles from "./home.module.css";

const ArticlesNews = () => {
  return (
    <div className={`${styles["articles-news"]} container sections-padding`}>
      <h2>Articles & News</h2>

     {articlesNewsData.map((ele) => (
  <div key={ele.id} data-aos="zoom-out-right">
    <span>{ele.about}</span>
    <h3>{ele.title}</h3>
    <p>{ele.description}</p>
    <button>Read More</button>
  </div>
))}

    </div>
  );
};

export default ArticlesNews;
